/**
 * Restricts a number to the inclusive range `[minValue, maxValue]`.
 *
 * Defaults to unit-range clamping (`0..1`) when bounds are omitted.
 */
export function clamp(num: number, minValue = 0, maxValue = 1): number {
  return Math.min(Math.max(num, minValue), maxValue);
}
